<template lang="pug">

    .field(:class='{ required: isRequired }')
        label(v-bind:for='fieldId' v-if='label !== undefined') {{ label }}
        input(
            type='text'
            v-bind:id='fieldId'
            v-model='model'
            v-bind:placeholder='placeholder'
            v-bind:readonly='isReadOnly'
            v-bind:disabled='disabled'
        )
        slot

</template>

<script>
    //noinspection ReservedWordAsName
    export default {
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        data() {
            return {
                fieldId: this.$rndId()
            }
        },

        props: {
            value: {
                required: true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
            },
            isReadOnly: {
                type: Boolean,
                default: false
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
            }
        }
    }

</script>
